import { Button, Card, Stack, ValidationErrors } from "@compass/core";
import {
  StudentParentEditResource,
  StudentParent as StudentParentModel,
  StudentParentViewResource,
} from "generated/openApi";
import { StudentParentPageBody } from "pages/students/student-parents/StudentParentPage/StudentParentPageBody";

export const StudentParent = (props: {
  studentParent: StudentParentModel;
  setStudentParent: (value: StudentParentModel) => void;
  viewResource: StudentParentViewResource;
  editResource: StudentParentEditResource;
  validationErrors: ValidationErrors;
  cancelCreate: () => void;
}) => {
  return (
    <Card>
      <Stack spacing="md">
        <StudentParentPageBody
          crudMode="edit"
          studentParent={props.studentParent}
          setStudentParent={props.setStudentParent}
          viewResource={props.viewResource}
          editResource={props.editResource}
          validationErrors={props.validationErrors || {}}
        />

        <Stack direction="row">
          <Button onClick={props.cancelCreate} variant="outlined">
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
};
